/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useLanguagesList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const LanguageSelect = ({ placeholder = 'Start typing the language name...', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useLanguagesList} {...props} />
);

export default LanguageSelect;
